var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickupApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 242,
    height: 174,
    viewBox: "0 0 242 174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94285",
    "data-name": "Path 94285",
    d: "M1623.1,204.038a3.64,3.64,0,0,1,3.734.294l35.544,20.522c3.144,1.815,5.7,6.691,5.7,10.883v95.341c0,2.061-.617,3.575-1.618,4.366l.011.03-6.35,3.666-2.961-8.052-29.213-16.866c-3.144-1.815-5.7-6.691-5.7-10.883l-1.11-80.039-4.389-15.6Z",
    transform: "translate(-1616.751 -203.649)",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94288",
    "data-name": "Path 94288",
    d: "M1665.977,324.3c0-3.733-2.272-8.076-5.073-9.693l-31.658-18.278c-2.8-1.616-5.073.1-5.073,3.835v91.824c0,3.733,2.273,8.077,5.073,9.693l31.658,18.278c2.8,1.617,5.073-.1,5.073-3.835Z",
    transform: "translate(-1624.173 -295.716)",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94303",
    "data-name": "Path 94303",
    d: "M1912.478,1682.967s5.657,27.811,6.084,38.22a10.189,10.189,0,0,1-12.3,2.311s-2.794-30.28-5.9-38.692C1900.359,1684.806,1904.343,1680.532,1912.478,1682.967Z",
    transform: "translate(-1900.359 -1682.217)",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94307",
    "data-name": "Path 94307",
    d: "M12.119.75s4.99,26.52,5.472,36.853c0,0-3.6,5.239-12.055,4.109C5.536,41.712,3.105,11,0,2.589,0,2.589,3.984-1.685,12.119.75Z",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48163",
    "data-name": "Group 48163",
    transform: "translate(-0.398 -0.406)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24086",
    "data-name": "Rectangle 24086",
    width: 242,
    height: 174,
    transform: "translate(0.399 0.407)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48162",
    "data-name": "Group 48162",
    transform: "translate(53.073 3.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94283",
    "data-name": "Path 94283",
    d: "M1620.951,1502.571c-2.424-1.4-6.1-1.552-8.2-.34l-10,5.772c-2.1,1.212-1.836,3.333.588,4.733l36.32,20.969c2.426,1.4,6.1,1.552,8.2.34l10-5.772c2.1-1.212,1.837-3.332-.589-4.733Z",
    transform: "translate(-1552.207 -1387.989)",
    fill: "#e1e3ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94284",
    "data-name": "Path 94284",
    d: "M1623.1,204.038a3.64,3.64,0,0,1,3.734.294l35.544,20.522c3.144,1.815,5.7,6.691,5.7,10.883v95.341c0,2.061-.617,3.575-1.618,4.366l.011.03-6.35,3.666-2.961-8.052-29.213-16.866c-3.144-1.815-5.7-6.691-5.7-10.883l-1.11-80.039-4.389-15.6Z",
    transform: "translate(-1566.373 -195.276)",
    fill: "#7887da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48142",
    "data-name": "Group 48142",
    transform: "translate(50.379 8.373)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24087",
    "data-name": "Rectangle 24087",
    width: 11.058,
    height: 100.112,
    transform: "translate(42.405 36.276)",
    fill: "#4b61dc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_94286",
    "data-name": "Path 94286",
    d: "M1639.421,281.051c0-4.191-2.551-9.067-5.7-10.883l-35.544-20.521c-3.144-1.815-5.7.115-5.7,4.306v95.341c0,4.192,2.552,9.068,5.7,10.883l35.544,20.521c3.145,1.816,5.7-.114,5.7-4.306Z",
    transform: "translate(-1544.072 -236.923)",
    fill: "#10243e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48144",
    "data-name": "Group 48144",
    transform: "translate(50.979 15.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94287",
    "data-name": "Path 94287",
    d: "M1665.977,324.3c0-3.733-2.272-8.076-5.073-9.693l-31.658-18.278c-2.8-1.616-5.073.1-5.073,3.835v91.824c0,3.733,2.273,8.077,5.073,9.693l31.658,18.278c2.8,1.617,5.073-.1,5.073-3.835Z",
    transform: "translate(-1624.173 -295.716)",
    fill: "#e1e3ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48143",
    "data-name": "Group 48143",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24088",
    "data-name": "Rectangle 24088",
    width: 41.805,
    height: 25.229,
    transform: "translate(-0.001 -4.54)",
    fill: "#f2f3f7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_94289",
    "data-name": "Path 94289",
    d: "M1701.033,675.475a2.58,2.58,0,0,0-1.077-2.058l-34.06-19.664c-.594-.343-1.077.022-1.077.814v8.262a2.58,2.58,0,0,0,1.077,2.057l34.06,19.664c.594.343,1.077-.022,1.077-.814Z",
    transform: "translate(-1610.55 -608.827)",
    fill: "#f2f3f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94290",
    "data-name": "Path 94290",
    d: "M1728.062,729.059a5.724,5.724,0,0,0-2.389-4.564L1699.46,709.36c-1.318-.761-2.389.048-2.389,1.806a5.725,5.725,0,0,0,2.389,4.564l26.213,15.134C1726.992,731.626,1728.062,730.817,1728.062,729.059Z",
    transform: "translate(-1640.191 -659.788)",
    fill: "#e1e3ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94291",
    "data-name": "Path 94291",
    d: "M1720.557,729.735a4.517,4.517,0,0,0-1.885-3.6l-11.023-6.364c-1.04-.6-1.885.038-1.885,1.425a4.517,4.517,0,0,0,1.885,3.6l11.023,6.364C1719.712,731.761,1720.557,731.122,1720.557,729.735Z",
    transform: "translate(-1648.18 -669.41)",
    fill: "#7887da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94292",
    "data-name": "Path 94292",
    d: "M1701.033,1430.257a2.581,2.581,0,0,0-1.077-2.058l-34.06-19.664c-.594-.343-1.077.021-1.077.814v8.262a2.58,2.58,0,0,0,1.077,2.058l34.06,19.664c.594.343,1.077-.021,1.077-.814Z",
    transform: "translate(-1610.55 -1302.511)",
    fill: "#f2f3f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1255",
    "data-name": "Ellipse 1255",
    cx: 2.842,
    cy: 3.281,
    rx: 2.842,
    ry: 3.281,
    transform: "translate(56.968 109.245)",
    fill: "#4b61dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1256",
    "data-name": "Ellipse 1256",
    cx: 2.842,
    cy: 3.281,
    rx: 2.842,
    ry: 3.281,
    transform: "translate(65.346 114.082)",
    fill: "#4b61dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1257",
    "data-name": "Ellipse 1257",
    cx: 2.842,
    cy: 3.281,
    rx: 2.842,
    ry: 3.281,
    transform: "translate(73.724 118.919)",
    fill: "#4b61dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1258",
    "data-name": "Ellipse 1258",
    cx: 2.842,
    cy: 3.281,
    rx: 2.842,
    ry: 3.281,
    transform: "translate(82.102 123.756)",
    fill: "#4b61dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94293",
    "data-name": "Path 94293",
    d: "M1701.033,855.4a2.685,2.685,0,0,0-1.12-2.141L1665.94,833.65c-.618-.357-1.12.023-1.12.847v17.752a2.685,2.685,0,0,0,1.12,2.141L1699.913,874c.618.357,1.12-.023,1.12-.847Z",
    transform: "translate(-1610.55 -774.156)",
    fill: "#f2f3f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94294",
    "data-name": "Path 94294",
    d: "M1701.033,1142.077a2.685,2.685,0,0,0-1.12-2.141l-33.973-19.614c-.618-.357-1.12.023-1.12.847v17.752a2.685,2.685,0,0,0,1.12,2.141l33.973,19.614c.618.357,1.12-.023,1.12-.847Z",
    transform: "translate(-1610.55 -1037.623)",
    fill: "#f2f3f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94295",
    "data-name": "Path 94295",
    d: "M1818.992,426.248a3.991,3.991,0,0,0-1.666-3.182l-8.919-5.149c-.919-.531-1.665.033-1.665,1.259a3.99,3.99,0,0,0,1.665,3.182l8.919,5.149C1818.246,428.038,1818.992,427.474,1818.992,426.248Z",
    transform: "translate(-1740.984 -392.016)",
    fill: "#10243e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94296",
    "data-name": "Path 94296",
    d: "M1771.027,521.276a3.991,3.991,0,0,0-1.668-3.183l-18.182-10.5c-.919-.531-1.665.033-1.665,1.259a3.99,3.99,0,0,0,1.665,3.182l18.182,10.5C1770.28,523.065,1771.027,522.5,1771.027,521.276Z",
    transform: "translate(-1688.387 -474.435)",
    fill: "#4b61dc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48145",
    "data-name": "Group 48145",
    transform: "translate(80.089 25.673) rotate(-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94297",
    "data-name": "Path 94297",
    d: "M2.411,9.515h0l.924-.533-.4-3.228V3.434A3.569,3.569,0,0,0,1.552.683L1.467,0,.543.533h0A1.268,1.268,0,0,0,0,1.74V6.627a3.515,3.515,0,0,0,1.467,2.8A.945.945,0,0,0,2.411,9.515Z",
    transform: "translate(0 0.061)",
    fill: "#4b61dc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94298",
    "data-name": "Path 94298",
    d: "M2.934,7.865c0,1.079-.657,1.577-1.466,1.109A3.517,3.517,0,0,1,0,6.171V1.284C0,.2.658-.291,1.468.176a3.514,3.514,0,0,1,1.466,2.8Z",
    transform: "translate(0.896 0)",
    fill: "#abb3db",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48154",
    "data-name": "Group 48154",
    transform: "translate(8.585 47.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48148",
    "data-name": "Group 48148",
    transform: "translate(8.588 51.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94299",
    "data-name": "Path 94299",
    d: "M1712.651,2190.514c6.454-4.133,11.817-4.277,18.354.622,5.006,3.751,14.309.551,15.009,4.388,2.133,11.682-14.439,5.4-21.4,1.379S1706.779,2194.275,1712.651,2190.514Z",
    transform: "translate(-1710.972 -2152.045)",
    fill: "#e1e3ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94300",
    "data-name": "Path 94300",
    d: "M1922.969,2005.232s7.11-.326,10.041-1.219,3.9,2.218.3,4.623-8.165,3.839-9.385,2.594S1922.969,2005.232,1922.969,2005.232Z",
    transform: "translate(-1896.853 -1966.028)",
    fill: "#10243e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48147",
    "data-name": "Group 48147",
    transform: "translate(15.738 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94301",
    "data-name": "Path 94301",
    d: "M1912.478,1682.967s5.657,27.811,6.084,38.22a10.189,10.189,0,0,1-12.3,2.311s-2.794-30.28-5.9-38.692C1900.359,1684.806,1904.343,1680.532,1912.478,1682.967Z",
    transform: "translate(-1900.359 -1682.217)",
    fill: "#4b61dc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48146",
    "data-name": "Group 48146",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94302",
    "data-name": "Path 94302",
    d: "M1919.019,1805.983l.438,2.684s-5.946,5.642-13.316,2.685l-.749-4.811Z",
    transform: "translate(-1905.393 -1801.47)",
    fill: "#10243e",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48151",
    "data-name": "Group 48151",
    transform: "matrix(0.968, 0.251, -0.251, 0.968, 11.672, 45.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94304",
    "data-name": "Path 94304",
    d: "M.023,1.34S6.786,1.022,9.574.152s3.713,2.16.287,4.5S2.094,8.4.934,7.182.023,1.34.023,1.34Z",
    transform: "translate(8.491 38.859) rotate(-7.243)",
    fill: "#10243e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48150",
    "data-name": "Group 48150",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94305",
    "data-name": "Path 94305",
    d: "M12.119.75s4.99,26.52,5.472,36.853c0,0-3.6,5.239-12.055,4.109C5.536,41.712,3.105,11,0,2.589,0,2.589,3.984-1.685,12.119.75Z",
    fill: "#4b61dc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48149",
    "data-name": "Group 48149",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94306",
    "data-name": "Path 94306",
    d: "M13.626,0l2.117,5.768s-5,5.968-14.994-.4L0,.559Z",
    transform: "translate(0 4.513)",
    fill: "#10243e",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_94308",
    "data-name": "Path 94308",
    d: "M1349.592,1152.722c2.69,1.848,2.769,5.615,2.792,9.384.018,2.959-2.5,8.369-2.5,8.369l2.387,11.639s-21.049,7.5-33.961-8.776l5.605-10.939,4.891-15.557S1346.1,1150.324,1349.592,1152.722Z",
    transform: "translate(-1310.131 -1124.799)",
    fill: "#7887da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48152",
    "data-name": "Group 48152",
    transform: "translate(37.91 16.993) rotate(17.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94309",
    "data-name": "Path 94309",
    d: "M4.272,10.182S1.061,10.051,0,7.416A14.378,14.378,0,0,1,2.265,2C3.887,0,4.99.1,7.043,0s1.808,1.62.489,1.806c-1.11.157-1.946.473-1.885.774a3.818,3.818,0,0,1,2.519,1.2c1.2,1.211-.454,2.8-.454,2.8A1.342,1.342,0,0,1,6.72,8.681S6.464,9.916,4.272,10.182Z",
    transform: "translate(25.075 6.468) rotate(-15.287)",
    fill: "#88daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94310",
    "data-name": "Path 94310",
    d: "M1.313,11.925s8.446.175,11.977-.282c1.759-.228,5.551-5.589,5.811-10.336A5.429,5.429,0,0,1,25.6.89c2.329,1.4,4.4,4.011,2.331,8.6a18.419,18.419,0,0,1-8.724,10.074c-4.83,2.637-12.094,1.49-17.951.082C1.257,19.641-1.608,15.255,1.313,11.925Z",
    transform: "matrix(0.829, 0.559, -0.559, 0.829, 11.823, 0)",
    fill: "#7887da",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_94311",
    "data-name": "Path 94311",
    d: "M8,4.16c.078-.379-1.988-.769-3.565-1.522A24.264,24.264,0,0,1,0,0S1.077,3.787,3.8,4.955C6.493,6.105,7.879,4.752,8,4.16Z",
    transform: "matrix(0.844, 0.536, -0.536, 0.844, 36.107, 35.919)",
    fill: "#10243e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48153",
    "data-name": "Group 48153",
    transform: "translate(4.769 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1259",
    "data-name": "Ellipse 1259",
    cx: 10.365,
    cy: 10.365,
    r: 10.365,
    transform: "translate(20.076 6.094)",
    fill: "#88daff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94312",
    "data-name": "Path 94312",
    d: "M1705.8,920.17s1.931-1.044,2.854-.2-2.333,3.358-2.333,3.358Z",
    transform: "translate(-1666.453 -905.163)",
    fill: "#88daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94313",
    "data-name": "Path 94313",
    d: "M1252.311,1143.34a6.7,6.7,0,0,0-3.121,4.239c-.877,3.165-1.894,6.024-4.609,6.317s-5.437,4.344-4.161,7.281c0,0-4.932.32-4.539,6.455s5.858,7.141,8.77,5.956c0,0,2.642,5.852,8.439,2.794,0,0,7.553,2.839,9.419-2.811,0,0,7.534-1.44,4.91-7.626,0,0,3.98-2.367,1.851-6.413s-1.382-5.954-1.382-5.954a5.071,5.071,0,0,0,2.033-4.82s7.023-3.094,5.223-8.22-8.092-6.6-10.532-1.608C1263.679,1136.219,1254.734,1135.456,1252.311,1143.34Z",
    transform: "translate(-1235.858 -1135.853)",
    fill: "#10243e",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48155",
    "data-name": "Group 48155",
    transform: "translate(99.375 44.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94314",
    "data-name": "Path 94314",
    d: "M1427.213,1109.945a1.829,1.829,0,0,1,1.815.135l12.37,6.849a6.283,6.283,0,0,1,2.764,5.066v12.751a2.319,2.319,0,0,1-.946,2.139l-.019.01-3.578,1.981-2.711-4.611-7.88-4.363a6.285,6.285,0,0,1-2.765-5.066v-8.678l-2.522-4.291Z",
    transform: "translate(-1422.778 -1109.762)",
    fill: "#40c3fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94315",
    "data-name": "Path 94315",
    d: "M1429.746,1145.612a6.229,6.229,0,0,0-2.706-5.034l-12.487-6.914c-1.493-.827-2.706.086-2.706,2.037v12.751a6.231,6.231,0,0,0,2.706,5.033l12.487,6.914c1.494.828,2.706-.086,2.706-2.037Z",
    transform: "translate(-1411.847 -1131.449)",
    fill: "#88daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24089",
    "data-name": "Rectangle 24089",
    width: 2.15,
    height: 4.755,
    transform: "translate(2.844 13.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24090",
    "data-name": "Rectangle 24090",
    width: 2.15,
    height: 6.796,
    transform: "translate(5.892 13.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24091",
    "data-name": "Rectangle 24091",
    width: 2.15,
    height: 9.796,
    transform: "translate(8.94 11.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24092",
    "data-name": "Rectangle 24092",
    width: 2.15,
    height: 7.656,
    transform: "translate(11.988 15.857)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48156",
    "data-name": "Group 48156",
    transform: "translate(99.375 69.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94316",
    "data-name": "Path 94316",
    d: "M1427.213,1109.945a1.829,1.829,0,0,1,1.815.135l12.37,6.849a6.283,6.283,0,0,1,2.764,5.066v12.751a2.319,2.319,0,0,1-.946,2.139l-.019.01-3.578,1.981-2.711-4.611-7.88-4.363a6.285,6.285,0,0,1-2.765-5.066v-8.678l-2.522-4.291Z",
    transform: "translate(-1422.778 -1109.762)",
    fill: "#40c3fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94317",
    "data-name": "Path 94317",
    d: "M1429.746,1145.612a6.229,6.229,0,0,0-2.706-5.034l-12.487-6.914c-1.493-.827-2.706.086-2.706,2.037v12.751a6.231,6.231,0,0,0,2.706,5.033l12.487,6.914c1.494.828,2.706-.086,2.706-2.037Z",
    transform: "translate(-1411.847 -1131.449)",
    fill: "#88daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94318",
    "data-name": "Path 94318",
    d: "M1468.433,1236.58l3.514-.314,3.515,4.372-3.515.313Zm3.165,4.869v4.686l-3.515-4.372v-4.686Zm4.212.089v4.686l-3.514.314v-4.686Z",
    transform: "translate(-1463.531 -1226.026)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48157",
    "data-name": "Group 48157",
    transform: "translate(99.375 94.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94319",
    "data-name": "Path 94319",
    d: "M1427.213,1109.945a1.829,1.829,0,0,1,1.815.135l12.37,6.849a6.283,6.283,0,0,1,2.764,5.066v12.751a2.319,2.319,0,0,1-.946,2.139l-.019.01-3.578,1.981-2.711-4.611-7.88-4.363a6.285,6.285,0,0,1-2.765-5.066v-8.678l-2.522-4.291Z",
    transform: "translate(-1422.778 -1109.762)",
    fill: "#40c3fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94320",
    "data-name": "Path 94320",
    d: "M1429.746,1145.612a6.229,6.229,0,0,0-2.706-5.034l-12.487-6.914c-1.493-.827-2.706.086-2.706,2.037v12.751a6.231,6.231,0,0,0,2.706,5.033l12.487,6.914c1.494.828,2.706-.086,2.706-2.037Z",
    transform: "translate(-1411.847 -1131.449)",
    fill: "#88daff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94321",
    "data-name": "Path 94321",
    d: "M2537.658,1911.048s.412.461.086,1.544a13.447,13.447,0,0,0-.6,4.74,6.676,6.676,0,0,0,.676,2.513,14.637,14.637,0,0,1-6.048-2.475,4.767,4.767,0,0,1-.778-2.548c-.082-1.88.792-3.974,1.035-5.473a2.056,2.056,0,0,0-.31-1.5A23.878,23.878,0,0,1,2537.658,1911.048Zm-4.93,3.469s.8.442,1.673.861a.209.209,0,0,0,.283-.11.228.228,0,0,0-.1-.3c-.859-.415-1.653-.851-1.653-.851a.209.209,0,0,0-.289.094A.232.232,0,0,0,2532.729,1914.518Zm.334-2.753a26.062,26.062,0,0,0,3.241,1.522.212.212,0,0,0,.265-.151.225.225,0,0,0-.143-.279,25.135,25.135,0,0,1-3.163-1.489.209.209,0,0,0-.288.094A.228.228,0,0,0,2533.063,1911.765Zm-.272,1.213a26.071,26.071,0,0,0,3.241,1.522.211.211,0,0,0,.265-.151.225.225,0,0,0-.143-.279,25.121,25.121,0,0,1-3.164-1.49.209.209,0,0,0-.288.094A.23.23,0,0,0,2532.79,1912.978Z",
    transform: "translate(-2526.247 -1898.828)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48158",
    "data-name": "Group 48158",
    transform: "translate(42.207 91.131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24093",
    "data-name": "Rectangle 24093",
    width: 51.433,
    height: 10.036,
    transform: "matrix(0.455, -0.891, 0.891, 0.455, 0, 45.804)",
    fill: "#88daff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24094",
    "data-name": "Rectangle 24094",
    width: 23.394,
    height: 16.939,
    transform: "translate(19.107 56.837)",
    fill: "#40c3fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24095",
    "data-name": "Rectangle 24095",
    width: 19.107,
    height: 16.939,
    transform: "translate(0 45.802)",
    fill: "#40c3fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24096",
    "data-name": "Rectangle 24096",
    width: 3.975,
    height: 7.736,
    transform: "translate(7.566 50.171)",
    fill: "#e1e3ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24097",
    "data-name": "Rectangle 24097",
    width: 23.716,
    height: 4.464,
    transform: "translate(7.622 50.204) rotate(-9.431)",
    fill: "#f2f3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48160",
    "data-name": "Group 48160",
    transform: "translate(79.316 133.351)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1260",
    "data-name": "Ellipse 1260",
    cx: 4.711,
    cy: 2.009,
    rx: 4.711,
    ry: 2.009,
    transform: "translate(2.573 22.457)",
    fill: "#e1e3ee"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1261",
    "data-name": "Ellipse 1261",
    cx: 6.356,
    cy: 2.5,
    rx: 6.356,
    ry: 2.5,
    transform: "translate(7.284 23.136)",
    fill: "#e1e3ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94322",
    "data-name": "Path 94322",
    d: "M2271.494,2235.819c-1.176-2.445-5.159-8.071-2.714-11.218,2.261-2.91,5.306,1.078,5.958,4.333,0,0-1.939-13.971,2.761-14.236s3.085,8.812,2.251,12.583c0,0,4.081-7.473,6.926-4.793s-6.458,14.363-6.458,14.363a5.339,5.339,0,0,1-4.382,2.42C2274.152,2239.282,2272.3,2237.486,2271.494,2235.819Z",
    transform: "translate(-2268 -2214.693)",
    fill: "#7887da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94323",
    "data-name": "Path 94323",
    d: "M2394.538,2189.807a.24.24,0,1,1,.479.03s-.972,15.338-2.448,21.306a.24.24,0,0,1-.466-.115C2393.573,2205.084,2394.538,2189.807,2394.538,2189.807Z",
    transform: "translate(-2384.813 -2186.438)",
    fill: "#f2f3f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94324",
    "data-name": "Path 94324",
    d: "M2346.195,2317.41a.24.24,0,0,1,.469-.1,20.62,20.62,0,0,0,1.518,4.278,6.657,6.657,0,0,0,2.763,3.179.24.24,0,1,1-.2.437,7.149,7.149,0,0,1-2.992-3.4A21.129,21.129,0,0,1,2346.195,2317.41Z",
    transform: "translate(-2342.621 -2303.651)",
    fill: "#f2f3f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94325",
    "data-name": "Path 94325",
    d: "M2407.5,2301.688a.24.24,0,1,1-.177-.446s5.12-2.024,7.082-6.09a.24.24,0,0,1,.432.208C2412.8,2299.578,2407.5,2301.688,2407.5,2301.688Z",
    transform: "translate(-2398.669 -2283.337)",
    fill: "#f2f3f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48159",
    "data-name": "Group 48159",
    transform: "translate(8.137 18.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94326",
    "data-name": "Path 94326",
    d: "M2385.161,2381.779c2.841-.032,2.058,1.929,3.845,3.085,1.637,1.059,1.6,3.373-1.024,3.851a14.27,14.27,0,0,1-6.666-.147c-3.274-.991-2.622-3.324-.528-4.006C2382.521,2384,2383.053,2381.8,2385.161,2381.779Z",
    transform: "translate(-2379.039 -2381.779)",
    fill: "#10243e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 0.656,
    cy: 0.632,
    rx: 0.656,
    ry: 0.632,
    transform: "translate(6.21 1.435)",
    fill: "#e1e3ee"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 0.33,
    cy: 0.302,
    rx: 0.33,
    ry: 0.302,
    transform: "translate(7.522 2.844)",
    fill: "#e1e3ee"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48161",
    "data-name": "Group 48161",
    transform: "translate(0 26.684) rotate(-45)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 18.869,
    cy: 18.869,
    r: 18.869,
    fill: "#4b61dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94327",
    "data-name": "Path 94327",
    d: "M0,2.443a2.443,2.443,0,1,1,4.886,0V9.282H16.763a2.443,2.443,0,1,1,0,4.886H2.443A2.443,2.443,0,0,1,0,11.725Z",
    transform: "translate(10.246 10.803)",
    fill: "#f2f3f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94328",
    "data-name": "Path 94328",
    d: "M6.892,1.03a1.954,1.954,0,0,1,3.443,0l6.889,12.839H0S4.379,5.713,6.892,1.03Z",
    transform: "translate(27.483 43.332) rotate(180)",
    fill: "#4b61dc",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupApproved);
export default __webpack_public_path__ + "static/media/PickupApproved.b1a262f81e149c6efdbc8dece8f75d06.svg";
export { ForwardRef as ReactComponent };